<template>
  <div
    class="input-custom-wrap"
    :class="[singleStatus ? configStyle : '']"
    v-track="{
      type: 'exposure',
      name: `${$route.params.type || 'phone'}.${
        $route.params.step || 'account'
      }`,
    }"
  >
    <el-input
      ref="custom-input"
      v-show="normalShow"
      class="input-custom"
      :class="{
        'is-password': isPassword,
        'is-float': float,
        'is-focus': focused,
        'none-placeholder': !$attrs.placeholer,
        'has-icon': isPassword,
      }"
      v-track="{
        type: ['focus', 'blur'],
        name: `${$route.params.type || 'phone'}.${
          $route.params.step || 'account'
        }.input`,
      }"
      v-bind="$attrs"
      v-on="$listeners"
      v-model="currentValue"
      @focus="onFocus"
      @blur="onBlur($event)"
      autocomplete="new-password"
      :tabindex="$attrs.tabIndexNum"
    >
      <template #prepend>
        <slot name="prepend"></slot>
      </template>
      <template #append>
        <slot name="append"></slot>
      </template>
      <template #suffix>
        <slot name="suffix"></slot>
      </template>
      <template #prefix v-if="$attrs.placeholer">
        <div class="input-custom-placeholder ellipsis">
          <slot name="prefix">{{ $attrs.placeholer }}</slot>
        </div>
      </template>
    </el-input>

    <el-input
      v-if="isPassword"
      v-show="!normalShow"
      class="input-custom has-icon"
      :class="{
        'is-float': float,
        'none-placeholder': !$attrs.placeholer,
      }"
      v-bind="$attrs"
      v-on="$listeners"
      v-model="currentValue"
      @focus="onFocus"
      @blur="onBlur($event)"
      autocomplete="new-password"
      type="text"
    >
      <template #prefix v-if="$attrs.placeholer">
        <div class="input-custom-placeholder ellipsis">
          <slot name="prefix">{{ $attrs.placeholer }}</slot>
        </div>
      </template>
    </el-input>

    <i
      class="icon-custom icon-clear"
      :class="{ show: currentValue && isPassword }"
      @click="clearValue"
    ></i>
    <i
      v-if="isPassword"
      class="icon-custom icon-eye"
      :class="{ 'icon-eye-close': !showPassword }"
      @click="handleEye"
    ></i>

    <slot name="btn" v-show="btnShow"></slot>
  </div>
</template>

<script>
import _throttle from 'lodash/throttle'
import { getBusinessType } from '@/constant'
export default {
  name: 'BaseInput',
  props: {
    value: [String, Array, Object, Number],
  },
  data() {
    return {
      showPassword: false,
      focused: false,
    }
  },
  computed: {
    autofocus() {
      return this.$attrs.autofocus === '' || this.$attrs.autofocus
    },
    normalShow() {
      return !this.isPassword || (this.isPassword && !this.showPassword)
    },
    isPassword() {
      return (
        this.$attrs.password === '' ||
        this.$attrs.password === true ||
        this.$attrs.type === 'password'
      )
    },
    btnShow() {
      return !this.$attrs.disabled
    },
    currentValue: {
      get() {
        return this.value
      },
      set(newV) {
        this.$emit('input', newV)
      },
    },
    float() {
      return this.focused ? true : !!this.value
    },
    singleStatus() {
      return getBusinessType().hasOwnThemeStyle
    },
    configStyle() {
      return getBusinessType().className
    },
  },

  mounted() {
    // 处理autofocus聚焦失败的问题
    this.$nextTick(() => {
      if (this.autofocus) {
        if (
          this.$refs['custom-input'] &&
          this.$refs['custom-input'].$refs.input
        ) {
          this.$refs['custom-input'].$refs.input.focus()
        }
      }
    })
  },

  methods: {
    handleEye: _throttle(function () {
      this.showPassword = !this.showPassword
    }, 500),
    clearValue() {
      this.currentValue = ''
    },
    onFocus() {
      this.focused = true
    },
    onBlur() {
      this.focused = false
    },
  },
}
</script>
<style lang="scss" scoped>
$gray: #a0a3bd;
.icon-custom {
  width: 24px;
  height: 24px;
  line-height: 0;
  z-index: 4;
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  vertical-align: top;
  display: none;
  &.icon-eye {
    right: 20px;
    display: block;
    background: url('../../assets/images/common/eye.svg');
  }
  &.icon-eye-close {
    background: url('../../assets/images/common/eye-off.svg');
  }
  &.icon-clear {
    right: 56px;
    background: url('../../assets/images/common/clear.svg');
  }
  &.show {
    display: block;
  }
}
.input-custom-wrap {
  position: relative;
}
</style>
<style lang="scss">
.input-custom-wrap.nissan-wrap {
  .input-custom.el-input .el-input__inner {
    background: rgba(0, 0, 0, 0.2);
    background-color: rgba(0, 0, 0, 0.2) !important;
    backdrop-filter: blur(50px);
    border-radius: 0 !important;
    border: none !important;
    border-top-right-radius: 2px !important;
    border-bottom-right-radius: 2px !important;
    color: #fff !important;
  }
  .input-custom {
    border-radius: 2px !important;
    border: 1px solid rgba(255, 255, 255, 0.4) !important;
    background-color: transparent !important;
    .el-input-group__prepend {
      border-top-left-radius: 2px !important;
      border-bottom-left-radius: 2px !important;
      .el-input__inner {
        border-top-left-radius: 2px !important;
        border-bottom-left-radius: 2px !important;
        border-top-right-radius: 0 !important;
        border-bottom-right-radius: 0 !important;
      }
    }
  }
  .input-custom.el-input:not(.is-disabled)
    .el-input-group__prepend
    .el-select
    .is-disabled
    .el-input__inner {
    background: rgba(0, 0, 0, 0.2);
    backdrop-filter: blur(50px);
  }

  .input-custom.el-input.el-input-group.el-input-group--prepend.is-focus {
    border-color: rgba(255, 255, 255, 0.4);
    background: transparent !important;
    backdrop-filter: blur(50px) !important;
    .el-input-group__prepend .el-select .el-input .el-input__inner {
      background: rgba(0, 0, 0, 0.2) !important;
      backdrop-filter: blur(50px) !important;
    }
    .el-input-group__prepend + .el-input__inner {
      background: rgba(0, 0, 0, 0.2) !important;
      backdrop-filter: blur(50px) !important;
    }
  }
  .input-custom-placeholder {
    color: rgba(255, 255, 255, 0.4) !important;
    font-size: 16px;
  }
  .input-custom.el-input .el-input__inner:focus {
    border-color: rgba(255, 255, 255, 0.4);
  }
  .input-custom.el-input .el-input__inner:hover {
    border-color: rgba(255, 255, 255, 0.4);
  }
  .el-tooltip.el-input-add-btn {
    border-radius: 0 !important;
    background-color: rgba(0, 0, 0, 0.3) !important;
    border: none !important;
    color: #fff;
    font-size: 14px;
  }
  .input-custom.el-input:not(.is-disabled)
    .el-input-group__prepend
    .el-select
    .is-disabled
    .el-input__inner {
    color: #fff;
  }
}
</style>
